/*
	Ajax-запросы в фоновом режиме
*/

backajax = {
	init: function() {
		$('.js-backajax:not(.ok)').each(function() {
			var
				$element = $(this);

			$element.on('click', function() {
				$element.attr('disabled', true);

				BX.ajax.post(
					$element.attr('data-url'), 
					{},
					function(result) {
						result = JSON.parse(result);

						if (result.result) {
							if (result.reload) {
								if (result.reload == true) location.reload();
								else location.href = result.reload;
							}

							else $element.attr('disabled', false);
						}
					}
				);
			});

			$element.addClass('ok');
		});
	}
}


$(document).ready(function() {
	backajax.init();
})